import { QueryClientProvider } from '@tanstack/react-query'
import { useLayoutEffect } from 'react'
import { Router } from './router/routes'
import { setGraphClientAuthToken } from './services/graph-client'
import { client } from './services/query-client'
import { useGlobalStore } from './store/global-store'
import type { TypeLive } from './types/lives/live'

export function App() {
  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)

    const myUserId = searchParams.get('myUserId')
    const liveId = searchParams.get('liveId')
    const liveUserId = searchParams.get('liveUserId')
    const liveCountry = searchParams.get('liveCountry')
    const typeLive = searchParams.get('typeLive')
    const token = searchParams.get('token')
    const isStreamer = searchParams.get('isStreamer')
    const utc = searchParams.get('utc')

    if (myUserId) {
      localStorage.setItem('@myUserId', myUserId)

      useGlobalStore.setState({ myUserId: Number(myUserId) })
    }

    if (liveId) {
      localStorage.setItem('@liveId', liveId)

      useGlobalStore.setState({ liveId: Number(liveId) })
    }

    if (liveUserId) {
      localStorage.setItem('@liveUserId', liveUserId)

      useGlobalStore.setState({ liveUserId: Number(liveUserId) })
    }

    if (liveCountry) {
      localStorage.setItem('@liveCountry', liveCountry)

      useGlobalStore.setState({ liveCountry: liveCountry })
    }

    if (typeLive) {
      localStorage.setItem('@typeLive', typeLive)

      useGlobalStore.setState({ typeLive: typeLive as TypeLive })
    }

    if (token) {
      localStorage.setItem('@token', token)

      setGraphClientAuthToken(token)

      useGlobalStore.setState({ token: token })
    }

    if (isStreamer) {
      localStorage.setItem('@isStreamer', isStreamer)

      useGlobalStore.setState({ isStreamer: isStreamer === 'true' })
    }

    if (utc) {
      localStorage.setItem('@utc', utc)

      useGlobalStore.setState({ utc })
    }
  }, [])

  return (
    <QueryClientProvider client={client}>
      <Router />
    </QueryClientProvider>
  )
}
